<template>
    <transition name="fade">
        <Edit v-if="editModal" :loja="loja" @changeVisibility="editModal = false" @close="closeEditModal"/>
    </transition>
    <section class="w-full px-8 py-8 h-full divide-y divide-gray-300 dark:divide-gray-700">
        <p class="dark:text-gray-200 text-gray-700 text-2xl tracking-widest uppercase">Loja</p>
        <div id="header-loja" class="w-full md:w-4/5 mx-auto">
            <div @click="dadosTab = !dadosTab" class="hover:bg-gray-200 dark:hover:bg-black px-2 py-2 flex justify-between items-center cursor-pointer">
                <p class="dark:text-gray-300 text-gray-700 text-xl uppercase">Informações</p>
                <div class="flex flew-row items-center space-x-6">
                    <transition name="fade">
                        <button v-if="dadosTab && loja" class="btn bg-indigo-500 rounded-full px-4 py-1 text-gray-100" @click.stop="editModal = true">
                            Editar informações
                        </button>
                    </transition>
                    <span :class="dadosTab ? 'transform rotate-180' : '' " class="material-icons-outlined text-gray-500 dark:text-gray-300 text-5xl transition-all duration-700">
                        expand_more
                    </span>
                </div>
            </div>
            <div :class="dadosTab ? 'h-80 mb-10' : 'h-0 mb-0'" class="transition-all duration-500">
                <transition name="fade">
                    <div v-if="loja && dadosTab" class="w-full md:w-11/12 mx-auto h-full rounded-lg">
                        <span class="flex flex-col md:flex-row justify-between py-2 gap-x-8">
                            <div class="flex flex-col justify-between h-full w-1/2">
                                <div><p class="text-2xl dark:text-indigo-400 text-indigo-600 truncate">{{loja.razao_social}}</p></div>
                                <div><p class="text-xl dark:text-indigo-200 text-indigo-400">{{loja.nome_fantasia}}</p></div>
                                <div><p class="text-base dark:text-gray-200 text-gray-600">{{cnpjMask(loja.cnpj)}}</p></div>
                                <div><p class="text-base dark:text-gray-200 text-gray-600 font-bold">{{loja.segmento}}</p></div>
                                <div><p :class="getStatusColor(loja.status.id)" class="text-sm font-bold">{{loja.status.descricao}}</p></div>
                                <div class="mt-2">
                                    <div class="mb-2">
                                        <p class="dark:text-indigo-200 text-indigo-200 text-xs uppercase">Nome do Contato</p>
                                        <p class="dark:text-gray-300 text-gray-500 text-sm">{{loja.nome_contato ? loja.nome_contato : 'Sem informação de contato'}}</p>
                                    </div>
                                    <div class="mb-2">
                                        <p class="dark:text-indigo-200 text-indigo-200 text-xs uppercase">Telefone 1</p>
                                        <p class="dark:text-gray-300 text-gray-500 text-sm">{{phoneMask(loja.telefone1) ? phoneMask(loja.telefone1) : 'Não há telefone primário'}}</p>
                                    </div>
                                    <div class="mb-2">
                                        <p class="dark:text-indigo-200 text-indigo-200 text-xs uppercase">Telefone 2</p>
                                        <p class="dark:text-gray-300 text-gray-500 text-sm">{{phoneMask(loja.telefone2) ? phoneMask(loja.telefone2) : 'Não há telefone secundário'}}</p>
                                    </div>
                                    <div>
                                        <p class="dark:text-indigo-200 text-indigo-200 text-xs uppercase">Email</p>
                                        <p class="dark:text-gray-300 text-gray-500 text-sm">{{loja.email}}</p>
                                    </div>
                                </div>
                                <div class="mt-4 flex flex-row items-center dark:text-gray-400 text-gray-500">
                                    <span class="material-icons md-12">location_on</span>
                                    <p class="uppercase text-xs break-words">{{loja.endereco.endereco}}, {{loja.endereco.numero}}, {{loja.endereco.bairro}} - {{loja.endereco.cidade}} - {{loja.endereco.estado}}</p>
                                </div>
                            </div>
                            <div class="w-auto self-center">
                                <div class="flex flex-col gap-y-2">
                                    <div>
                                        <p class="text-center text-base dark:text-gray-500 text-gray-600 uppercase">Última Recolha</p>
                                        <p class="text-center text-lg dark:text-indigo-200 text-indigo-600">{{loja.ultima_recolha ? dateMask(loja.ultima_recolha) : 'Não há recolhas para essa loja'}}</p>
                                    </div>
                                    <div>
                                        <p class="text-center text-base dark:text-gray-500 text-gray-600 uppercase">Região</p>
                                        <p class="text-center text-lg dark:text-indigo-200 text-indigo-600">{{loja.endereco.regiao}}</p>
                                    </div>
                                    <div>
                                        <p class="text-center text-base dark:text-gray-500 text-gray-600 uppercase">Faturamento</p>
                                        <p class="text-center text-lg dark:text-indigo-200 text-indigo-600">{{loja.faturamento}}</p>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </div>
                    <div v-else-if="!loja" class="flex">
                        <section class="rounded-lg mt-40 text-indigo-100 flex flex-row justify-center w-full">
                            <p class="text-4xl text-center animate-pulse ">Carregando loja</p>
                            <Spinner class="mt-3 ml-2 " width="3"/>
                        </section>
                    </div>
                </transition>
            </div>
        </div>
        <div class="w-4/5 mx-auto">
            <div @click="recolhasTab = !recolhasTab" class="hover:bg-gray-200 dark:hover:bg-black px-2 py-2 flex justify-between items-center cursor-pointer">
                <p class="dark:text-gray-300 text-gray-700 text-xl uppercase">Recolhas</p>
                <span :class="recolhasTab ? 'transform rotate-180' : '' " class="material-icons-outlined text-gray-500 dark:text-gray-300 text-5xl transition-all duration-700">
                    expand_more
                </span>
            </div>
            <div :class="recolhasTab ? 'h-102' : 'h-0'" class="transition-all duration-500">
                <transition name="fade">
                    <PesquisaRecolha v-show="recolhasTab"/>
                </transition>
            </div>
        </div>
        <div class="w-4/5 mx-auto pb-8">
            <div @click="produtosTab = !produtosTab" class="hover:bg-gray-200 dark:hover:bg-black px-2 py-2 flex justify-between items-center cursor-pointer">
                <p class="dark:text-gray-300 text-gray-700 text-xl uppercase">Produtos cadastrados</p>
                <span :class="produtosTab ? 'transform rotate-180' : '' " class="material-icons-outlined text-gray-500 dark:text-gray-300 text-5xl transition-all duration-700">
                    expand_more
                </span>
            </div>
            <div :class="produtosTab ? 'h-auto mb-32' : 'h-0'" class="transition-all duration-500">
                <transition name="fade">
                    <ProdutosLojas v-show="produtosTab"/>
                </transition>
            </div>
        </div>

    </section>
</template>

<script>
import { onMounted, onUnmounted, ref } from '@vue/runtime-core'
import { GET_LOJA_ATIVA_BY_ID } from '../../mixins/api'
import { useRoute } from 'vue-router'
import { telephoneMask, cnpjMask as cnpj_mask, dateTimeFormat } from '../../mixins/mask.js'
import ProdutosLojas from '../Produtos/ProdutosLoja.vue'
import PesquisaRecolha from '../Pesquisa/ProcurarRecolha.vue'
import Edit from '../EditEmpresaModal/Modal.vue'
import { getStatusColor as getColor } from '../../mixins/colors'
import Spinner from '../Design/Spinner.vue'

export default {
    name: 'DetalheLoja',
    components: {
        ProdutosLojas,
        PesquisaRecolha,
        Edit,
        Spinner
    },
    setup () {
        const route = useRoute()
        const loja = ref(null)

        const phoneMask = telephoneMask
        const cnpjMask = cnpj_mask
        const dateMask = dateTimeFormat

        const dadosTab = ref(true)
        const recolhasTab = ref(false)
        const produtosTab = ref(false)

        const getStatusColor = getColor

        const handleScroll = () => {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                document.getElementById('header-loja').style.fontSize = '30px'
            } else {
                document.getElementById('header-loja').style.fontSize = '90px'
            }
        }

        onMounted(async () => {
            window.addEventListener('scroll', handleScroll)
            GET_LOJA_ATIVA_BY_ID(route.params.id).then(r => {
                loja.value = r.data.data
            })
        })

        onUnmounted(() => {
            window.removeEventListener('scroll', handleScroll)
        })

        const editModal = ref(false)

        const closeEditModal = async () => {
            await GET_LOJA_ATIVA_BY_ID(route.params.id).then(r => {
                loja.value = r.data.data
            })
            editModal.value = false
        }
        return {
            loja,
            phoneMask,
            cnpjMask,
            dateMask,
            getStatusColor,
            dadosTab,
            recolhasTab,
            produtosTab,
            editModal,
            closeEditModal
        }
    }
}
</script>

<style>
.fade-enter-from {
  opacity: 0;
  /* transform: translateY(-10%); */
}
.fade-enter-to {
  opacity: 1;
  /* transform: translateY(0%); */
}

.fade-enter-active {
  transition: all 0.3s ease-in-out;
  transition-delay: 0.2s;
}

.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
  /* transform: translateY(0%); */
}

.fade-leave-to {
  opacity: 0;
  /* transform: translateY(10%); */
}

</style>
